"use strict";

exports.get = function (params) {
  return params.ssl ? 'https' : 'http';
};